import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme.js"
import themeTokens from "conversion_flows/theme/LibUIThemeTokens"
import "website_script/lib/events"
import ModuleTypes from "../constants/ModuleTypes"
import type { Theme } from "website_script/types/theme"
import { DeprecatedProduct } from "website_script/lib/events"
import { FlowType } from "conversion_flows/types/scalars"

/**
 * Whether or not the current view port is of mobile size
 */
export function isMobile(): boolean {
  return window.matchMedia("only screen and (max-width: 760px)").matches
}

/**
 * For a given module type, it returns a product to track
 *
 */
export function productTypeForModuleType(
  moduleType: ModuleTypes
): DeprecatedProduct {
  switch (moduleType) {
    case ModuleTypes.TRADE_IN:
      return "trade_in"
    case ModuleTypes.BOOK_TEST_DRIVE:
      return "test_drive"
    case ModuleTypes.SIMILAR_CARS:
      return "similar_cars_widget"
    default:
      return "website_script"
  }
}

/**
 * For a given module type, it returns a set of changes to be applied to the base theme
 */
export function customThemeForModuleType(
  moduleType: ModuleTypes,
  dealerTheme: DealerTheme
): Partial<Theme> | null {
  const tokens = themeTokens(dealerTheme)

  switch (moduleType) {
    case ModuleTypes.BOOK_TEST_DRIVE:
    case ModuleTypes.PRICE_ALERT:
    case ModuleTypes.CUSTOM:
      return {
        modalBackgroundColor: tokens("colors.white") as string,
        containerMaxWidth: tokens("containerSizes.md") as string,
        modalPadding: tokens("spacing.md") as string,
      }
    default:
      return null
  }
}

export function getModuleTypeFromFlowType(flowType: FlowType): ModuleTypes {
  switch (flowType) {
    case "trade_in":
      return ModuleTypes.TRADE_IN
    case "test_drive":
      return ModuleTypes.BOOK_TEST_DRIVE
    case "price_alert":
      return ModuleTypes.PRICE_ALERT
    case "custom":
      return ModuleTypes.CUSTOM
    case "call":
      return ModuleTypes.CALL
    case "router":
      return ModuleTypes.ROUTER
    case "message":
      return ModuleTypes.MESSAGE
    case "get_better_price":
      throw new Error("get_better_price is deprecated")
  }
}

export function getFlowTypeFromModuleType(
  moduleType: ModuleTypes
): FlowType | null {
  switch (moduleType) {
    case ModuleTypes.BOOK_TEST_DRIVE:
      return "test_drive"
    case ModuleTypes.TRADE_IN:
      return "trade_in"
    case ModuleTypes.PRICE_ALERT:
      return "price_alert"
    case ModuleTypes.CALL:
      return "call"
    case ModuleTypes.MESSAGE:
      return "message"
    case ModuleTypes.ROUTER:
      return "router"
    case ModuleTypes.CUSTOM:
      return "custom"
    case ModuleTypes.SIMILAR_CARS:
      return null
  }
}

// Not all module types can be used as inline buttons
// ex. call and message is not supported
export type InlineButtonSupportedModuleTypes =
  | ModuleTypes.TRADE_IN
  | ModuleTypes.PRICE_ALERT
  | ModuleTypes.CUSTOM
  | ModuleTypes.BOOK_TEST_DRIVE

export function getInlineButtonSupportedModuleTypes(
  flowType: FlowType
): InlineButtonSupportedModuleTypes {
  switch (flowType) {
    case "trade_in":
      return ModuleTypes.TRADE_IN
    case "test_drive":
      return ModuleTypes.BOOK_TEST_DRIVE
    case "price_alert":
      return ModuleTypes.PRICE_ALERT
    case "custom":
      return ModuleTypes.CUSTOM
    default:
      return ModuleTypes.TRADE_IN
  }
}
